import React from "react";

const ErrorField = ({ errMessage }) => {
  return errMessage === "" ? null : (
    <div className="error bold">{errMessage}</div>
  );
};

export default ErrorField;
